import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { api } from "../lib/api";
import { applyGeo, getGeo, savedCountry, chooseCountry } from "../lib/currency";

export const CurrencyGate = ({ children }) => {
  const [ready, setReady] = useState(!!localStorage.getItem("dx-geo"));
  const [key, setKey] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 2500);
    const before = getGeo().currency;
    api.get("/geo", { params: savedCountry() ? { country: savedCountry() } : {} })
      .then((r) => { applyGeo(r.data); if (r.data.currency !== before) setKey((k) => k + 1); })
      .catch(() => {})
      .finally(() => { clearTimeout(t); setReady(true); });
    return () => clearTimeout(t);
  }, []);
  return ready ? <div key={key} className="contents">{children}</div> : null;
};

export const CountryPicker = ({ light = false, testid = "country-picker" }) => {
  const g = getGeo();
  if (!g.countries?.length) return null;
  return (
    <label className={`inline-flex items-center gap-1.5 text-xs font-semibold ${light ? "text-white/85" : "text-[#5B2A6E]"}`} title="Prices shown in your local currency">
      <Globe className="w-4 h-4 shrink-0" />
      <select value={g.country_code} onChange={(e) => chooseCountry(e.target.value)} data-testid={testid}
        className={`bg-transparent outline-none cursor-pointer max-w-[110px] sm:max-w-none ${light ? "[&>option]:text-[#250E31]" : ""}`}>
        {!g.countries.find((c) => c.code === g.country_code) && <option value={g.country_code}>{g.country_name} · {g.currency}</option>}
        {g.countries.map((c) => <option key={c.code} value={c.code}>{c.name} · {c.currency}</option>)}
      </select>
    </label>
  );
};
